<template>
	<div v-click-outside="closeModal" class="app-top-info__edit-container">
		<div class="app-top-info__edit-container__title">{{ truncatedTitle }}</div>
		<div
			v-if="showEditModal && !isQuestionButton && !isForumPage"
			@click="showModal"
			:class="
				!isOpenModal
					? 'app-top-info__edit-container__modal-button'
					: 'app-top-info__edit-container__modal-button-active'
			"
		>
			<Icon type="ellipsis" :size="20" :color="'var(--text_button_tint)'" />
		</div>
		<div
			@click="openAskModal"
			class="app-top-info__edit-container__qn-button"
			v-if="isQuestionButton"
		>
			Ask
		</div>
		<div v-if="isOpenModal" class="app-top-info__edit-container__modal-button__modal">
			<div
				v-if="isMyPost"
				@click="toggleEditPostModal"
				class="app-top-info__edit-container__modal-button__edit"
			>
				{{ editTitle }}
			</div>
			<div
				v-if="isForumPost && !isMyPost"
				@click="toggleReportModal"
				class="app-top-info__edit-container__modal-button__edit"
			>
				Report Inappropriate
			</div>
			<div
				v-if="isMyPost"
				@click="toggleDeletePostModal"
				class="app-top-info__edit-container__modal-button__delete"
			>
				{{ deleteTitle }}
			</div>
		</div>
		<div v-if="isForumPage" class="app-top-info__forum-tabs">
			<span :class="{ active: activeTab }" @click="setForumTab(true)" class="py-2">
				Discussions
			</span>
			<span :class="{ active: !activeTab }" @click="setForumTab(false)" class="py-2">
				About
			</span>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { EventBus } from '@/services/event-bus'
import Dwh from '@/mixins/Dwh'

export default {
	data() {
		return {
			isOpenModal: false,
			activeTab: true,
		}
	},
	mixins: [Dwh],
	computed: {
		...mapGetters('advertisement', ['isTypePost', 'isMyPost']),
		...mapGetters('app', ['pageTitle']),
		showEditModal() {
			const routeName = this.$route.name

			const routesConfig = {
				'posts-by-id': this.isMyPost,
				'forum-by-id': true,
				'event-session-questions': true,
				'forums-by-category-id': true,
			}

			return !!routesConfig[routeName]
		},
		editTitle() {
			if (this.isForumPost) return 'Edit Discussion'
			if (this.isTypePost) return 'Edit Poll'
			return 'Edit Post'
		},
		deleteTitle() {
			return this.isForumPost ? 'Delete Discussion' : 'Delete Post'
		},
		truncatedTitle() {
			const maxLength = 40
			if (!this.pageTitle) return ''
			return this.pageTitle.length > maxLength
				? this.pageTitle.slice(0, maxLength) + '...'
				: this.pageTitle
		},
		isForumPost() {
			return this.$route.name === 'forum-by-id'
		},
		isQuestionButton() {
			return this.$route.name === 'event-session-questions'
		},
		isForumPage() {
			return this.$route.name === 'forums-by-category-id'
		},
	},
	watch: {
		$route: {
			handler() {
				if (!this.isForumPage) return

				this.setForumTab(true)
			},
			immediate: true,
		},
	},
	methods: {
		...mapActions('advertisement', ['togglePostModal', 'togglePostDeleteModal']),
		...mapActions('forum', ['reportingModal']),
		dwhDeleteClickTrigger() {
			this.sendTrigger({
				category: 'Moderation',
				action: 'click_delete_discussion',
				module: 'Forums / Communities',
				title: this.$route.query.title,
				id1: this.$route.params.id,
			})
		},
		dwhReportClickTrigger() {
			this.sendTrigger({
				category: 'Moderation',
				action: 'click_report_discussion',
				module: 'Forums / Communities',
				title: this.$route.query.title,
				id1: this.$route.params.id,
			})
		},
		showModal() {
			this.isOpenModal = !this.isOpenModal
			if (this.$route.name === 'forum-by-id') {
				this.sendTrigger({
					category: 'Discussion Post',
					action: 'click_three_dots_discussion',
					module: 'Forums / Communities',
					title: this.$route.query.title,
					id1: this.$route.params.id,
				})
			}
		},
		openAskModal() {
			EventBus.$emit('openQuestionModal')
		},
		setForumTab(isList) {
			this.activeTab = isList
			EventBus.$emit('toggleForumList', isList)
		},
		toggleEditPostModal() {
			this.togglePostModal()
			EventBus.$emit('openEditForumModal')
			this.isOpenModal = false
		},
		toggleReportModal() {
			this.reportingModal()
			this.dwhReportClickTrigger()
			this.isOpenModal = false
		},
		toggleDeletePostModal() {
			this.togglePostDeleteModal()
			if (this.$route.name === 'forum-by-id') {
				this.dwhDeleteClickTrigger()
			}
			this.isOpenModal = false
		},
		closeModal() {
			if (!this.isOpenModal) return
			this.isOpenModal = false
		},
	},
}
</script>

<style lang="scss">
.app-top-info {
	&__forum-tabs {
		display: flex;
		gap: 16px;

		span {
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			cursor: pointer;
			color: #9b9b9b;
			position: relative;
		}

		.active {
			color: var(--primary_color);

			&::after {
				content: '';
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				height: 1px;
				background: var(--primary_color);
			}
		}
	}
	&__edit-container {
		max-width: 555px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		&__qn-button {
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--text_button_tint);
			cursor: pointer;
		}

		&__title {
			max-width: 300px !important;
			width: 100%;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: clamp(14px, 2.5vw, 24px);
			line-height: 100%;
			white-space: nowrap;
			color: #4a4a4a;
		}
		&__modal-button-active {
			width: 40px;
			height: 40px;
			border: 1.5px solid var(--text_button_tint);
			box-shadow: 0 0 0 2px #0055a333;
			border-radius: 8px;
			padding: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
		}

		&__modal-button {
			width: 40px;
			height: 40px;
			border: 1px solid #e2e2e2;
			border-radius: 8px;
			padding: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;

			&__modal {
				width: 250px;
				position: absolute;
				top: 45px;
				right: 0;
				background-color: #ffffff;
				padding: 12px;
				z-index: 1000;
				border-radius: 8px;
				border: 1px solid #e2e2e2;
			}

			&__edit {
				padding: 12px;
				cursor: pointer;
				font-family: 'Inter', sans-serif;
				font-weight: 400;
				font-size: 12px;
				line-height: 16.94px;
				color: #4a4a4a;
			}

			&__delete {
				padding: 12px;
				cursor: pointer;
				font-family: 'Inter', sans-serif;
				font-weight: 400;
				font-size: 12px;
				line-height: 16.94px;
				color: #ff3b30;
			}
		}
	}
}
</style>
